export default {
  no_storefront_found: {
    title: 'Nenhuma loja encontrada',
    description: 'Por favor, crie uma loja.',
  },
};
